import type { FormatFunction } from 'i18next';

// Formats usable in locale strings, e.g. `{{ defaultEmployeeLabel, ucfirst }}`.
const interpolationFormat: FormatFunction = (value, format) => {
  if (!value) {
    return value;
  }

  if (format === 'lowercase') {
    return value.toLowerCase();
  }

  if (format === 'uppercase') {
    return value.toUpperCase();
  }

  if (format === 'capitalize') {
    const strLower = value.toLowerCase();
    return strLower.charAt(0).toUpperCase() + strLower.slice(1);
  }

  if (format === 'ucfirst') {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  return value;
};

export default interpolationFormat;
